const IframeTest = ({url}: {url: string}) => {

    return (
        <iframe
            style={{borderRadius: '10px'}}
            id="mainIframe"
            src={url}
            width="800"
            height="500"
        />
    );
};

export default IframeTest;
